module.exports = __webpack_public_path__ + "./docs/img/icon-prop.f0c147239d8902aa30963c79af4782cd.svg";